class NavRail {
    constructor($el, $highlight) {
        this.$el = $el;
        this.$highlight = $highlight;
    }

    goto(top, selected) {
        const height = this.$highlight.height();
        this.$el.css('top', `${top * height * -1}px`);
        this.$highlight.css('top', `${(selected - top) * height}px`);
    }
}

export default NavRail;
